import { useContext } from "react"
import { Wrapper, Page, Timeline, Fade } from "components"
import type { FC, HTMLAttributes } from "react"

interface SectionProps
extends HTMLAttributes<HTMLDivElement> {}

export const CareerTimeline: FC<SectionProps> = ({ children, ...props }) => {
  const { content } = useContext(Page.Context)

  return (
    <Page.Section.Container {...props} id="experience">
      <Fade>
        <Wrapper double>
          <Page.Section.Heading number={2}>
            {content.careerHeading}
          </Page.Section.Heading>
          <Page.Section.Delimiter />
          <Page.Section.Description shrink
            content={content.careerDescription} />
          <Timeline.Container>
            {[...content.careerList].reverse().map((item: any, index: number) => (
              <Timeline.Item key={index} {...item} /> 
            ))}
          </Timeline.Container>
        </Wrapper>    
      </Fade>
    </Page.Section.Container>
  )
}
